import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  dialog: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '680px',
        maxWidth: '90vw',
        maxHeight: '85vh',
        overflowY: 'unset',
        height: '65vh',
        minHeight: '550px',
        borderRadius: '12px',
        boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.12)}`,
        border: `1px solid ${theme.palette.border.subtle}`,
      },
    },
  },
  dialogTitle: {
    textAlign: 'left',
    padding: '20px 24px',
    borderBottom: `1px solid ${theme.palette.border.subtle}`,
    borderRadius: '12px 12px 0 0',
    '& .MuiTypography-root': {
      fontSize: '18px',
      fontWeight: '600',
    },
  },
  customizedButton: {
    position: 'absolute',
    right: '16px',
    top: '16px',
    padding: '6px',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.status.neutral.background,
      color: theme.palette.extendedGrey.dark,
    },
  },
  dialogContent: {
    padding: '0',
  },
  dialogContentFlex: {
    padding: '0',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  roomContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  roomInner: {
    maxWidth: '100%',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  chatBox: {
    width: '100%',
  },
  callEndedContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '40px 24px',
    gap: '16px',
  },
  callEndedIconWrapper: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: theme.palette.status.neutral.background,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  callEndedIcon: {
    fontSize: 32,
    color: theme.palette.extendedGrey.neutral,
  },
  callEndedTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  callEndedDescription: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    textAlign: 'center' as const,
    maxWidth: 360,
    lineHeight: 1.5,
  },
  callEndedActions: {
    display: 'flex',
    gap: '12px',
    marginTop: '12px',
  },
  callEndedPrimaryButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: theme.shape.borderRadius,
    padding: '8px 24px',
    fontSize: '14px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  callEndedSecondaryButton: {
    textTransform: 'none' as const,
    fontWeight: 600,
    borderRadius: theme.shape.borderRadius,
    padding: '8px 24px',
    fontSize: '14px',
    color: theme.palette.extendedGrey.dark,
    borderColor: theme.palette.border.strong,
    '&:hover': {
      borderColor: theme.palette.extendedGrey.neutral,
      backgroundColor: theme.palette.surface.raised,
      color: theme.palette.extendedGrey.dark,
    },
  },
}));
